var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51581 6.15084C8.15831 6.50834 8.15831 7.08584 8.51581 7.44334L12.0725 11L8.51581 14.5567C8.15831 14.9142 8.15831 15.4917 8.51581 15.8492C8.87331 16.2067 9.45081 16.2067 9.80831 15.8492L14.0158 11.6417C14.3733 11.2842 14.3733 10.7067 14.0158 10.3492L9.80831 6.14168C9.45997 5.79334 8.87331 5.79334 8.51581 6.15084Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIcon);
export default __webpack_public_path__ + "static/media/ChevronRightIcon.3abf69caed35cfc08325483f6faeee43.svg";
export { ForwardRef as ReactComponent };